import Pagination from '@mui/material/Pagination'
import styled from 'styled-components'

const ListPaginationRoot = styled(Pagination)``

export { ListPaginationRoot }
